export default {
      id: "pay_stripe-usage",
      viewBox: "0 0 38 17",
      url: __webpack_public_path__ + "sprite.svg#pay_stripe",
      toString: function () {
        return this.url;
      }
    }